module.exports = __webpack_public_path__ + "img/s-square.b4ce6105.svg";